export default __webpack_public_path__ + "static/media/all_services.1a153fc5.jpeg";